<template>
	<div id="clear-page">
		<div class="page-box">
			<!-- 部分闪耀星星样式 -->
			<div class="star star1"></div>
			<div class="star star2"></div>
			<div class="star star3"></div>
			<div class="star star4"></div>
			<div class="star star5"></div>
			<div class="star star6"></div>
			<div class="star star7"></div>

			<!-- 页面主体内容 -->
			<!-- 页面标题 -->
			<div class="page-head">
				<!-- <img src="../assets/clear/clear-top.png" class="head-img"> -->
				<div class="head-word">{{head_word}}</div>

				<div class="today">{{nowTime}}</div>
				<div class="company-info">
					<img src="../assets/logo.png" class="bottom-logo">
					<div class="info-box">
						<div>{{company_info}}</div>
					</div>
				</div>
			</div>
			<!-- 页面下半部分 -->
			<div class="right-left">
				<div class="item">
					<div class="left-bar">
						<!-- 小组排行 -->
						<div class="title-box">
							<img src="../assets/clear/clear-titile.png" class="title-img">
							<div class="title-txt">签约总进度</div>
						</div>
						<div class="bar-div">
							<div class="bar-box">
								<div class="chart-box">
									<!-- 3D饼图区域 -->
									<!-- 参考资料：https://blog.csdn.net/weixin_39921970/article/details/120627345；https://www.yisu.com/zixun/691980.html -->
									<!-- <div class="warning-pie" id="pieChart"></div> -->
									<!-- 参考资料：https://code84.com/455501.html -->
									<div :id="pieId" :option="option"></div>
								</div>
							</div>
							<!-- <div v-else class="no-list">
								暂无工作进度
							</div> -->
						</div>
					</div>
					<div class="left-photo">
						<!-- 工作照 -->
						<div class="title-box">
							<img src="../assets/clear/clear-titile.png" class="title-img">
							<div class="title-txt">最新签约动态</div>
						</div>
						<div class="photo-div" v-if="tableList.length>0">
							<!-- 轮播图 -->
							<!-- <swiperCom style="width: 100%;height: 100%;" :gallery="gallery"></swiperCom> -->
							<div class="tabel-box" v-for="(item,index) in tableList" :key="index">
								<div>{{index == 0?"序号":index}}</div>
								<div class="address">{{item.F_RoomCode}}</div>
								<div>{{item.F_ShortName}}</div>
								<div>{{item.F_SigningDate?`${(item.F_SigningDate).split(' ')[0]}`:"--"}}</div>
							</div>
						</div>
						<div v-else class="no-img">
							暂无签约
						</div>
					</div>
				</div>
				<div class="item">
					<div class="data-box">
						<!-- 数据概况 -->
						<div class="data-item" v-for="(item,index) in dataList" :key="index">
							<div class="item-box">
								<!-- <img src="../assets/clear/data-item1.png" class="item-img"> -->
								<img :src="index == hightLingtIndex ?itemImg1:itemImg" class="item-img">
								<div class="item-word">
									<div class="num" :style="index== hightLingtIndex?'color:#FFDA30':''">{{item.num}}
									</div>
									<div class="text" :style="index== hightLingtIndex?'color:#ccae26':''">{{item.text}}
									</div>
									<div class="unit" :style="index== hightLingtIndex?'color:#ccae26':''">{{item.unit}}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="line-right">
						<!-- 地图模块 -->
						<div class="title-box">
							<img src="../assets/clear/clear-title2.png" class="title-img">
							<div class="title-txt" style="display: flex;align-items: flex-end;top:52%;">小组签约进度</div>
						</div>
						<div class="map-div">
							<div ref="echartestBar" style="width: 100%;height: 100%;"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import HighCharts from "highcharts";
	import * as echarts from 'echarts';
	// Vue.prototype.$echarts = echarts;
	import RollNum from "../components/common/RollNum.vue";
	import Swiper from '../components/common/Swiper.vue'
	export default {
		name: 'Clear',
		components: {
			rollNum: RollNum,
			swiperCom: Swiper
		},
		data() {
			return {
				head_word: "裕亨花园土地整备项目签约数据大屏",
				company_info: "国房·智慧征拆平台",
				now: "",
				timer: null, //定义计时器
				timer2: null, //定义定时器2
				nowTime: "", //现在时间，精确到秒
				hightLingtIndex: 0, //定时轮询高亮的index
				dataList: [{
						text: "总栋数",
						num: 8,
						unit: "（栋）"
					}, {
						text: "总户数",
						num: 477,
						unit: "（户）"
					},
					{
						text: "已签约数",
						num: 0,
						unit: "（户）"
					}, {
						text: "签约率",
						num: 0,
						unit: "（%）"
					}, {
						text: "今日签约",
						num: 0,
						unit: "（户）"
					}
				],
				itemImg1: require('../assets/clear/data-item3.png'),
				itemImg: require('../assets/clear/data-item2.png'),
				gallery: [], //工作实照数组
				legendList: [{
						text: "租户签约总数",
						type: "block",
						num: 0
					},
					{
						text: "租户已签约数",
						type: "block",
						num: 0
					}
				],
				getMapDataLoading: true,
				tableList: [], //左侧签约表格数据
				pieId: "pieID",
				//图表样式
				option: {
					chart: {
						type: "pie", //饼图
						options3d: {
							enabled: true, //使用3d功能
							alpha: 60, //延y轴向内的倾斜角度
							beta: 0,
						},
						backgroundColor: 'rgba(0, 0, 0, 0)', // 不显示背景色
						width: 550,
						height: 300 //设置大小是为了饼图能在想要的区域中显示
					},
					title: {
						text: "", //图表的标题文字，置空
					},
					subtitle: {
						text: "", //副标题文字，置空
					},
					credits: {
						enabled: false //禁用版权url，置空
					},
					plotOptions: {
						pie: {
							allowPointSelect: true, //每个扇块能否选中
							cursor: "pointer", //鼠标指针
							innerSize: 60,
							depth: 20, //饼图的厚度
							dataLabels: {
								enabled: true, //是否显示饼图的线形tip
								distance: 24, //设置引导线的长度          
								color: '#fff', //全局设置字体颜色
								style: {
									textOutline: 'none', //去掉文字白边 
									fontSize: '18'
								},
								formatter: function() {
									return (
										this.point.name + this.y //+ '%'
									)
								}
							},
						},
					},
					series: [{
						type: "pie",
						name: "户数", //统一的前置词,非必须
						data: [{
								name: '已签约：',
								y: 0,
								color: 'rgb(145, 232, 225)'
							},
							{
								name: '未签约：',
								y: 478,
								color: 'rgb(244, 91, 91)'
							}
						],
					}]
				},
			}
		},
		mounted() {
			this.getRequest();
			this.getTime();
			//循环器30秒请求接口
			this.timer = setInterval(() => {
				this.getRequest(); //获取接口数据
			}, 30000);

			// 在 DOM 挂载后初始化柱形图ECharts
			// this.setTest();
			//渲染扇形图
			HighCharts.chart(this.pieId, this.option);
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval((this.timer));
			};
			if (this.timer2) {
				clearInterval(this.timer2);
			}
		},
		methods: {
			//获取数据操作
			getRequest() {
				const loading = this.$loading({
					lock: true,
					text: '获取最新数据中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.3)'
				});
				this.request.get("/h5/main/getsigndata").then((res) => {
					if (res.code == 200) {
						setTimeout(function() {loading.close()}, 1500);
						// console.log("接口数据", res.data);
						// return;
						let resObj = res.data;

						//顶部部分数据
						//resObj.TotalData
						// resObj.TotalData.TotalNoSignCount; //未签约数
						this.dataList[2].num = resObj.TotalData.TotalSignCount; //已签约数
						this.dataList[4].num = resObj.TotalData.TodaySignCount; //今日签约数
						// 计算签约率（保留一位小数）
						const totalHouseholds = this.dataList[1].num;
						const signedHouseholds = resObj.TotalData.TotalSignCount;
						const signingRate1 = (signedHouseholds / totalHouseholds * 100).toFixed(1); //.toFixed(2)
						this.dataList[3].num = `${signingRate1}`;

						//扇形图echart
						this.option.series[0].data[0].y = resObj.TotalData.TotalSignCount; //已签约
						this.option.series[0].data[1].y = resObj.TotalData.TotalNoSignCount; //未签约
						HighCharts.chart(this.pieId, this.option);

						//柱形图ECharts
						//resObj.groupData小组柱形图数据
						let xArray = [];
						let yArray = [];
						let totalArr = [];
						for (var i = 0; i < resObj.groupData.length; i++) {
							let item = resObj.groupData[i];
							xArray.push(item.F_ShortName);
							yArray.push(item.count_signed);
							totalArr.push(item.count_all);
						}
						this.setTest(xArray, yArray, totalArr);

						//柱形图数据
						this.tableList = resObj.topData;
						this.tableList.unshift({
							"F_RoomCode": "房屋地址",
							"F_ShortName": "小组",
							"F_SigningDate": "日期"
						})
					} else {
						// loading.close();
						console.log("BigScreenData非200")
					}
				})
			},
			//获取右上角时间
			getTime() {
				this.timer2 = setInterval(() => {
					let timeDate = new Date();
					let year = timeDate.getFullYear();
					let mounth = timeDate.getMonth() + 1;
					let day = timeDate.getDate();
					let hours = timeDate.getHours();
					hours = hours >= 10 ? hours : "0" + hours;
					let minutes = timeDate.getMinutes();
					minutes = minutes >= 10 ? minutes : "0" + minutes;
					let seconds = timeDate.getSeconds();
					seconds = seconds >= 10 ? seconds : "0" + seconds;
					let week = timeDate.getDay();
					let weekArr = [
						"星期日",
						"星期一",
						"星期二",
						"星期三",
						"星期四",
						"星期五",
						"星期六",
					];
					this.nowTime = `${year}-${mounth}-${day} ${hours}:${minutes}:${seconds} ${weekArr[week]}`
					// this.nowTime = `${hours}:${minutes}:${seconds} ${weekArr[week]}`

					if (this.hightLingtIndex == 4) {
						this.hightLingtIndex = 0;
					} else {
						this.hightLingtIndex += 1;
					}
				}, 1000);
			},
			setTest(xArr, yArr, totalArr) {
				let xAx = xArr || ['签约一组', '签约二组', '签约三组', '签约四组']; //x轴显示内容
				let yAy = yArr || []; //Y轴数值
				let total = totalArr;
				let myChart = echarts.init(this.$refs.echartestBar);
				let option = {
					// title: {
					// 	subtext: "各小组签约进度"
					// },
					tooltip: {
						// showContent: true, // 确保这是你想要的设置
						// formatter: function (params) { ... } // 如果使用了formatter，确保它不会总是返回内容

						// 参考资料https://www.cnblogs.com/qiuyueding/p/8042225.html
						// trigger: 'item',
						// formatter: "{b}:{c}", //提示文本为x轴字段：值
						// textStyle: { //提示文本的样式
						// 	color: '#fff',
						// 	fontsize: 12,
						// }

						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						},
						formatter: function(params) {
							const total = params[0].value;
							const completed = params[1].value;
							const rate = (completed / total * 100).toFixed(1) + '%';
							return `${params[0].name}<br/>总数: ${total}<br/>已完成: ${completed}<br/>完成率: ${rate}`;
						}
					},
					//右上角色块标识
					// legend: {
					// 	data: ['总数', '已完成'],
					// 	top: 30
					// },
					grid: {
						left: '2%', // 减少左侧边距
						right: '2%', // 减少右侧边距
						bottom: '2%', // 底部边距
						containLabel: true // 确保标签不会被裁剪
					},
					xAxis: {
						type: 'category',
						data: xAx,
					},
					yAxis: {
						//设置y轴显示字段
						type: 'value',
						name: '签约进度',
					},
					series: [{
						name: '总数',
						type: 'bar',
						barWidth: '60%', // 设置相同的宽度
						z: 1, // 确保在底层
						barGap: '-100%', // 关键配置：使柱子100%重叠
						//方案二在option最外层添加
						// seriesLayoutBy: 'row',
						label: {
							show: true,
							position: 'top',
							color: '#fff',
							formatter: function(params) {
								// 当已完成=总数时隐藏总数标签
								const completed = option.series[1].data[params.dataIndex];
								return params.value === completed ? '' : params.value;
							}
						},
						itemStyle: {
							color: 'rgba(255,255,255,0.3)',
							opacity: 0.3 // 半透明效果
						},
						data: total
					}, {
						name: '已完成',
						type: 'bar',
						barWidth: '60%', // 设置相同的宽度
						z: 2, // 确保在上层
						label: {
							show: true,
							position: 'top', //top inside
							color: '#fff',
							formatter: function(params) {
								const total = option.series[0].data[params.dataIndex];
								const rate = (params.value / total * 100).toFixed(1) + '%';
								return params.value === total ? `${params.value}\n(100%)` :
									`${params.value}\n(${rate})`;
							}
						},
						itemStyle: {
							color: '#009db7'
						},
						data: yAy
					}]
				};
				myChart.setOption(option);
			}
		}
	}
</script>

<style lang="scss" scoped>
	* {
		padding: 0;
		margin: 0;
	}

	#clear-page {
		background-color: #071c26;
		width: 100vw;
		height: 100vh;
		overflow: hidden;
		user-select: none;

		.page-box {
			width: 100%;
			height: 100%;
			background: url("../assets/clear/back.png") no-repeat;
			position: relative;

			.page-head {
				position: relative;
				height: 60px;

				.head-img {
					width: 100vw;
				}

				.head-word {
					position: absolute;
					left: 50%;
					top: 20%;
					transform: translateX(-50%);
					color: #fff;
					font-size: 1.8vw;
					letter-spacing: 0.18vw;
					font-weight: bold;
					white-space: nowrap;
				}


				.today {
					font-size: 16px;
					position: absolute;
					top: 18%;
					right: 1.5%;
					color: #fff;
					font-size: 1.2vw;
				}

				.company-info {
					position: absolute;
					top: 50%;
					left: 1%;
					transform: translateY(-50%);
					// color: #515151;
					color: #fff;
					font-size: 1.2vw;
					// font-weight: bold;
					display: flex;
					align-items: center;
					justify-content: center;

					.bottom-logo {
						display: inline-block;
						width: 2.4vw;
						margin-right: 10px;
					}

					.info-box {
						display: flex;
						flex-direction: column;
						align-items: flex-end;
						justify-content: center;
					}
				}
			}

			.right-left {
				width: 100vw;
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 16px 10px;

				.item {
					// width: 40vw;
					height: 92vh;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					align-items: center;


					.title-box {
						width: 100%;
						position: relative;

						.title-txt {
							color: #fff;
							font-size: 20px;
							position: absolute;
							font-weight: bold;
							left: 9%;
							top: 48%;
							transform: translateY(-50%);
						}

						.title-img {
							width: 100%;
							display: block;
						}
					}

					.left-bar {
						background: #03171F80;
						width: 100%;

						.bar-div {
							width: 30vw;
							margin: 0 auto;
							height: 34vh;
							display: flex;
							justify-content: center;

							.no-list {
								color: #fff;
								align-self: center;
								font-size: 1vw;
							}

							.bar-box {
								color: #fff;
								position: relative;
								width: 100%;
								// height: 100%;
								height: 90%;
								display: flex;
								flex-direction: column;
								justify-content: space-around;

								.list-title {
									display: flex;
									align-items: center;
									justify-content: flex-end;

									div {
										font-size: 14px;
										margin-right: 12px;
									}
								}

								.item {
									display: flex;
									margin-bottom: 10px;

									.item-left {
										flex: 1;
									}

									.item-line {
										flex: 5;
										display: flex;
										align-items: center;
										justify-content: space-around;

										.line-box {
											display: flex;
											justify-content: center;
											align-items: center;
											flex-direction: column;

											.right-column-inner {
												background: #ffffff10;
												width: 100%;
												height: 1vw;
												margin-bottom: 2px;
												overflow: hidden;

												.block {
													height: 100%;
													background: #065ea2;
												}
											}

											.line-word {
												font-size: 12px;
											}
										}
									}
								}

								.list-item {
									position: absolute;
									left: 0;
									width: 98%;
									transition: all 2s;

									display: flex;
									align-items: flex-start;
									justify-content: flex-start;
									margin-bottom: 40px;

									.item-left {
										flex: 2;
										// padding-top: 4px;
										font-size: 18px;
										text-align: center;
									}

									.item-right {
										flex: 10;

										.right-column {
											width: 100%;
											height: 8px;
											background: #ffffff10;
											margin-bottom: 4px;

											.right-column-inner {
												width: 0px;
												height: 100%;
												background: #3bebd6;
											}
										}

										.right-word {
											font-size: 14px;
											color: #9c9c9c;

											p {
												margin: 0;
												display: inline-block;
												margin-right: 16px;

												span {
													color: #fff;
												}
											}
										}
									}
								}
							}
						}
					}

					.left-photo {
						background: #03171F80;
						margin-top: 20px;
						width: 30vw;
						height: 100%;
						padding-bottom: 1px;

						.photo-div {
							height: 100%;
							width: 100%;
							// display: flex;
							// align-items: center;
							overflow: hidden;
							color: #fff;

							.tabel-box {
								display: flex;
								flex-wrap: nowrap;
								align-items: center;
								justify-content: space-around;

								.address {
									max-width: 35%;
									text-overflow: ellipsis;
									overflow: hidden;
								}
							}

							.tabel-box>div {
								padding: 13px 30px 13px 0;
								white-space: nowrap;
								width: 100%;
								text-align: center;
							}
						}

						.no-img {
							color: #fff;
							height: 100%;
							display: flex;
							align-items: center;
							justify-content: center;
						}
					}

					.line-right {
						width: 94%;
						height: 68vh;
						// background: #ffffff20; //方便查看布局

						.title-txt {
							left: 3%;
						}

						.map-status {
							color: #fff;
							margin-top: 10px;
							padding: 0 1vw 10px;
							display: flex;
							justify-content: flex-start;
							align-items: center;

							.map-status-lie {
								display: flex;
								justify-content: flex-start;
								align-items: center;

								.status0,
								.status1,
								.status2,
								.status3,
								.status4 {
									width: 16px;
									height: 16px;
									display: inline-block;
									background: #065ea2;
									margin: 0 6px;
								}

								.line0 {
									width: 16px;
									height: 3px;
									background-color: #ff3f00;
									margin: 0 6px;
								}



								.status1 {
									background: #065ea2;
								}

								.status2 {
									background: #fff706;
								}

								.status3 {
									background: #32cd32;
								}
							}
						}

						.map-div {
							width: 100%;
							height: 96%;
							border-radius: 10px;
							overflow: hidden;



							.map-border {
								--borderWidth: 10px;
								--bRadius: 10px;
								width: 100%;
								height: 100%;
								position: relative;
								z-index: 0;
								overflow: hidden;
								z-index: 0;
								border-radius: --bRadius;
								// padding: 6px;

								&::after,
								&::before {
									box-sizing: border-box;
								}

								&::before {
									content: '';
									position: absolute;
									z-index: -2;
									left: -50%;
									top: -50%;
									width: 200%;
									height: 200%;
									background-color: #1a232a;
									background-repeat: no-repeat;
									background-position: 0 0;
									background-image: conic-gradient(transparent, rgba(168, 239, 255, 1), transparent 30%);
									animation: rotate 4s linear infinite;
								}

								&::after {
									content: '';
									position: absolute;
									z-index: -1;
									left: calc(var(--borderWidth) / 2);
									top: calc(var(--borderWidth) / 2);
									width: calc(100% - var(--borderWidth));
									height: calc(100% - var(--borderWidth));
									background: #233d4b;
									border-radius: 5px;
									/* 这句效果打开有助于理解动画 */
									/*animation: opacityChange 5s infinite linear;*/
								}

								.map-loading {
									position: absolute;
									left: 0;
									top: 0;
									width: 100%;
									height: 100%;
									background: rgba(000, 000, 000, 0.5);
									z-index: 6;
									color: #fff;
									display: flex;
									align-items: center;
									justify-content: center;
								}

								.map-box {
									width: 99%;
									height: 98%;
									position: absolute;
									top: 50%;
									left: 50%;
									border-radius: 6px;
									overflow: hidden;
									transform: translate(-50%, -50%);
								}




								.block-box {
									position: absolute;
									right: 10px;
									bottom: 17px;
									width: 160px;
									font-size: 14px;
									// min-height: 200px;
									background: rgba(000, 000, 000, 0.5);
									border-radius: 8px;
									padding: 20px 10px 10px 10px;
									color: #fff;
									z-index: 5;

									.block-line {
										display: flex;
										justify-content: flex-start;
										align-items: center;
										margin-bottom: 10px;

										.status0,
										.status1,
										.status2,
										.status3,
										.status4 {
											width: 16px;
											height: 16px;
											display: inline-block;
											background: #065ea2;
											margin: 0 6px;
										}

										.line0 {
											width: 16px;
											height: 3px;
											background-color: #ff3f00;
											margin: 0 6px;
										}



										.status1 {
											background: #065ea2;
										}

										.status2 {
											background: #fff706;
										}

										.status3 {
											background: #32cd32;
										}
									}
								}
							}
						}
					}

					.data-box {
						width: 94%;
						height: 10vw;
						margin-top: 2vw;
						display: flex;
						justify-content: space-around;
						align-items: center;
						background-image: url("../assets/clear/data-back.png");
						background-size: 100% auto;
						background-repeat: no-repeat;
						background-position: bottom;

						.data-item {
							width: 18%;
							height: 68%;
							display: flex;
							align-items: flex-end;
							justify-content: center;

							// background: #ffffff20; //方便查看布局
							.item-box {
								position: relative;
								display: flex;
								justify-content: center;
								align-items: center;

								.item-img {
									width: 6vw;
								}

								.item-word {
									position: absolute;
									left: 50%;
									transform: translateX(-50%);
									top: -20%;
									display: flex;
									justify-content: center;
									align-items: center;
									flex-direction: column;
									color: #CCD6D680;
									width: 100%;
									font-size: 14px;

									.num {
										font-size: 1.5vw;
										color: #23FFFC;
										font-weight: bold;
									}

									.text {
										white-space: nowrap;
										text-align: center;
									}
								}
							}
						}
					}
				}
			}

			.page-line {
				width: 100vw;
				box-sizing: border-box;
				// background: #ffffff20;//方便查看布局
				padding: 0 1vw;
				display: flex;
				justify-content: space-between;
				align-items: flex-start;


				.content-box {
					width: 28vw;
					height: 14vw;
					position: relative;
					margin: 14px 0;
					background: #03171F80;


					.chart-box {
						display: flex;
						justify-content: center;
						align-items: center;
						position: absolute;
						left: 50%;
						top: 25%;
						transform: translateX(-50%);

						.warning-pie {
							width: 450px;
							height: 210px;
						}
					}

				}



				.line-left {
					width: 28vw;
					// background: #ffffff20; //方便查看布局
				}

			}


			.star {
				position: absolute;
				background-color: #20ebe8;
				border-radius: 50%;
			}

			.star1 {
				left: 27.8%;
				top: 19.2%;
				width: 8px;
				height: 8px;
				animation: twinkle linear 1s infinite alternate;
				-webkit-animation: twinkle linear 1s infinite alternate;
			}

			.star2 {
				left: 16%;
				top: 2.9%;
				width: 6px;
				height: 6px;
				background-color: #fff;
				animation: twinkle linear 2s infinite alternate;
				-webkit-animation: twinkle linear 2s infinite alternate;
			}

			.star3 {
				width: 9px;
				height: 9px;
				left: 25.5%;
				top: 15.2%;
				background-color: #fff;
				border-radius: 0;
				transform: rotate(45deg);
				animation: twinkle linear 2s infinite alternate;
				-webkit-animation: twinkle linear 2s infinite alternate;
			}

			.star4 {
				width: 4px;
				height: 4px;
				left: 60%;
				top: 13%;
				animation: twinkle linear 1s infinite alternate;
				-webkit-animation: twinkle linear 1s infinite alternate;
			}



			.star5 {
				right: 16%;
				top: 2.9%;
				width: 5px;
				height: 5px;
				animation: twinkle linear 2s infinite alternate;
				-webkit-animation: twinkle linear 2s infinite alternate;
			}

			.star6 {
				right: 10%;
				top: 1.5%;
				width: 8px;
				height: 8px;
				background-color: #fff;
				animation: twinkle linear 3s infinite alternate;
				-webkit-animation: twinkle linear 3s infinite alternate;
			}

			.star7 {
				right: 6%;
				top: 10%;
				width: 6px;
				height: 6px;
				animation: twinkle linear 3s infinite alternate;
				-webkit-animation: twinkle linear 3s infinite alternate;
			}
		}
	}

	@keyframes opacityChange {
		50% {
			opacity: .5;
		}

		100% {
			opacity: 1;
		}
	}

	@keyframes rotate {
		100% {
			transform: rotate(1turn);
		}
	}

	@keyframes twinkle {
		0% {
			opacity: 0;
		}

		50% {
			opacity: 0.5;
		}

		100% {
			opacity: 1;
		}
	}
</style>